const actions = {

    INITIAL: 'INITIAL',
    LOGIN_BEGIN: 'LOGIN_BEGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERR: 'LOGIN_ERR',
    LOGOUT_BEGIN: 'LOGOUT_BEGIN',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_ERR: 'LOGOUT_ERR',


    FORGOT_BEGIN: 'FORGOT_BEGIN',
    FORGOT_SUCCESS: 'FORGOT_SUCCESS',
    FORGOT_ERR: 'FORGOT_ERR',

    OTP_BEGIN: 'OTP_BEGIN',
    OTP_SUCCESS: 'OTP_SUCCESS',
    OTP_ERR: 'OTP_ERR',

    CHANGE_BEGIN: 'CHANGE_BEGIN',
    CHANGE_SUCCESS: 'CHANGE_SUCCESS',
    CHANGE_ERR: 'CHANGE_ERR',

    CHECK_STORE_BEGIN: 'CHECK_STORE_BEGIN',
    CHECK_STORE_SUCCESS: 'CHECK_STORE_SUCCESS',
    CHECK_STORE_ERR: 'CHECK_STORE_ERR',

    SURVEY_QUIZ_BEGIN: 'SURVEY_QUIZ_BEGIN',
    SURVEY_QUIZ_SUCCESS: 'SURVEY_QUIZ_SUCCESS',
    SURVEY_QUIZ_ERR: 'SURVEY_QUIZ_ERR',
    SURVEY_QUIZ_SKIP_BEGIN: 'SURVEY_QUIZ_SKIP_BEGIN',
    SURVEY_QUIZ_SKIP_SUCCESS: 'SURVEY_QUIZ_SKIP_SUCCESS',
    SURVEY_QUIZ_SKIP_ERR: 'SURVEY_QUIZ_SKIP_ERR',
    SURVEY_QUIZ_UPDATE_TOKEN_BEGIN: 'SURVEY_QUIZ_UPDATE_TOKEN_BEGIN',
    SURVEY_QUIZ_UPDATE_TOKEN_SUCCESS: 'SURVEY_QUIZ_UPDATE_TOKEN_SUCCESS',
    SURVEY_QUIZ_UPDATE_TOKEN_ERR: 'SURVEY_QUIZ_UPDATE_TOKEN_ERR',
    SURVEY_QUIZ_SUBMIT_BEGIN: 'SURVEY_QUIZ_SUBMIT_BEGIN',
    SURVEY_QUIZ_SUBMIT_SUCCESS: 'SURVEY_QUIZ_SUBMIT_SUCCESS',
    SURVEY_QUIZ_SUBMIT_ERR: 'SURVEY_QUIZ_SUBMIT_ERR',
    SURVEY_QUIZ_SNOOZED: 'SURVEY_QUIZ_SNOOZED',
    SURVEY_QUIZ_RESET: 'SURVEY_QUIZ_RESET',


    initial:() => {
        return {
            type: actions.INITIAL,
        };
    },

    loginBegin: () => {
        return {
            type: actions.LOGIN_BEGIN,
        };
    },

    loginSuccess: (data,loginData) => {
        return {
            type: actions.LOGIN_SUCCESS,
            data:data,
            login:data,
            loginData:loginData,
        };
    },

    loginErr: (err) => {
        return {
            type: actions.LOGIN_ERR,
            err,
        };
    },

    logoutBegin: () => {
        return {
            type: actions.LOGOUT_BEGIN,
        };
    },

    logoutSuccess: (data) => {
        return {
            type: actions.LOGOUT_SUCCESS,
            data,
            login:false,
            loginData:'',
        };
    },

    logoutErr: (err) => {
        return {
            type: actions.LOGOUT_ERR,
            err,
        };
    },

    forgotBegin: () => {
        return {
            type: actions.FORGOT_BEGIN,
        };
    },

    forgotSuccess: (data,username) => {
        return {
            type: actions.FORGOT_SUCCESS,
            data:data,
            username:username,
        };
    },

    forgotErr: (err) => {
        
        return {
            type: actions.FORGOT_ERR,
            err,
        };
    },

    otpBegin: () => {
        return {
            type: actions.OTP_BEGIN,
        };
    },

    otpSuccess: (data) => {
        return {
            type: actions.OTP_SUCCESS,
            data:data,
            error:''
        };
    },

    otpErr: (err) => {
        return {
            type: actions.OTP_ERR,
            err,
        };
    },

    changeBegin: () => {
        return {
            type: actions.CHANGE_BEGIN,
        };
    },

    changeSuccess: (data) => {
        return {
            type: actions.CHANGE_SUCCESS,
            data:data,
        };
    },

    changeErr: (err) => {
        return {
            type: actions.CHANGE_ERR,
            err,
        };
    },

    checkStoreBegin: (router) => {
        return {
            type: actions.CHECK_STORE_BEGIN,
            router,
        };
    },

    checkStoreSuccess: (allowed, router, lockType, message, details, gateMeetingReport, isTvDownloaded) => {
        return {
            type: actions.CHECK_STORE_SUCCESS,
            allowed: allowed,
            router,
            lockType,
            message,
            details,
            gateMeetingReport,
            isTvDownloaded,
        };
    },

    checkStoreErr: (err, router, lockType) => {
        return {
            type: actions.CHECK_STORE_ERR,
            err,
            router,
            lockType,
        };
    },

    surveyQuizBegin: (router) => {
        return {
            type: actions.SURVEY_QUIZ_BEGIN,
            router,
        };
    },

    surveyQuizSuccess: (data, router, uniqueToken) => {
        return {
            type: actions.SURVEY_QUIZ_SUCCESS,
            data,
            router,
            uniqueToken,
        };
    },

    surveyQuizErr: (err, router) => {
        return {
            type: actions.SURVEY_QUIZ_ERR,
            err,
            router,
        };
    },

    surveyQuizSkipBegin: () => {
        return {
            type: actions.SURVEY_QUIZ_SKIP_BEGIN,
        };
    },

    surveyQuizSkipSuccess: (data) => {
        return {
            type: actions.SURVEY_QUIZ_SKIP_SUCCESS,
            data,
        };
    },

    surveyQuizSkipErr: (err) => {
        return {
            type: actions.SURVEY_QUIZ_SKIP_ERR,
            err,
        };
    },

    surveyQuizUpdateTokenBegin: () => {
        return {
            type: actions.SURVEY_QUIZ_UPDATE_TOKEN_BEGIN,
        };
    },

    surveyQuizUpdateTokenSuccess: (data) => {
        return {
            type: actions.SURVEY_QUIZ_UPDATE_TOKEN_SUCCESS,
            data,
        };
    },

    surveyQuizUpdateTokenErr: (err) => {
        return {
            type: actions.SURVEY_QUIZ_UPDATE_TOKEN_ERR,
            err,
        };
    },

    surveyQuizSubmitBegin: () => {
        return {
            type: actions.SURVEY_QUIZ_SUBMIT_BEGIN,
        };
    },

    surveyQuizSubmitSuccess: (data) => {
        return {
            type: actions.SURVEY_QUIZ_SUBMIT_SUCCESS,
            data,
        };
    },

    surveyQuizSubmitErr: (err) => {
        return {
            type: actions.SURVEY_QUIZ_SUBMIT_ERR,
            err,
        };
    },

    surveyQuizSnoozed: (router, uniqueToken) => {
        return {
            type: actions.SURVEY_QUIZ_SNOOZED,
            router,
            uniqueToken,
        };
    },

    surveyQuizReset: () => {
        return {
            type: actions.SURVEY_QUIZ_RESET,
        };
    },


};

export default actions;
